import { Box, Skeleton } from '@mui/material';
import CustomerReviewsSkeleton from './CustomerReviewsSkeleton';

const PCCustomerReviewsLoadingSkeleton = () => {
  return (
    <div className="mx-[2.5%] mt-[36px]">
      <div className="mb-[32px] flex justify-center">
        <Skeleton variant="text" width={220} height={44} />
      </div>

      <div className="mb-[32px] flex items-start justify-center bg-[#f7f7f7] px-[40px] py-[33px]">
        <Box className="mr-[40px] flex w-[150px] min-w-[130px] flex-col items-start">
          <Skeleton variant="text" width={110} height={72} />
          <Skeleton variant="rectangular" width={104} height={24} />
        </Box>

        <Box className="flex w-[336px] min-w-[336px] flex-col justify-between">
          {['5', '4', '3', '2', '1'].map((star) => (
            <Box
              key={star}
              className="mb-[10px] flex w-[336px] min-w-[336px] items-center justify-between last:mb-0"
            >
              <Skeleton variant="text" width={52} height={20} />
              <Skeleton variant="rectangular" width={236} height={6} className="mx-[10px]" />
              <Skeleton variant="text" width={30} height={20} />
            </Box>
          ))}
        </Box>

        <Box className="ml-[15.625vw] flex flex-col">
          <Skeleton variant="text" width={260} height={36} className="mb-[32px]" />
          {[1, 2, 3].map((item) => (
            <Box
              key={item}
              className="mb-[10px] flex w-[257px] min-w-[257px] items-center justify-between last:mb-0"
            >
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="rectangular" width={165} height={6} className="mx-[5px]" />
              <Skeleton variant="text" width={28} height={20} />
            </Box>
          ))}
        </Box>
      </div>

      <div className="flex flex-wrap gap-[16px] px-[13%] py-[32px]">
        {[1, 2, 3, 4].map((item) => (
          <Skeleton key={item} variant="rounded" width={128} height={40} />
        ))}
      </div>

      <div className="px-[13%]">
        <div className="relative border-b border-[#eeeeee] pb-[12px]">
          <div className="flex gap-[32px]">
            <Skeleton variant="text" width={90} height={32} />
            <Skeleton variant="text" width={110} height={32} />
          </div>
          <div className="absolute right-0 top-1/2 -translate-y-1/2">
            <Skeleton variant="rounded" width={136} height={32} />
          </div>
        </div>

        <div className="mt-[15px]">
          <CustomerReviewsSkeleton isWeb count={2} />
        </div>
      </div>
    </div>
  );
};

export default PCCustomerReviewsLoadingSkeleton;
